<div class="navigation-wrap">
    <a href="https://upscapital.com/" target="_blank" rel="noopener noreferrer">
        <img class="logo" src="../../../../assets/images/logos/flexLogo.png">
    </a>
    <div class="nav-welcome-mobile">
        <span>
            <img class="logo" src="../../../../assets/images/logos/flexLogo.png" alt="Login">
        </span>
    </div>
</div>